import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotFeed from "./components/HotFeed";
import RankSection from "./components/RankSection";
import FollowUp from "./components/FollowUp";
import Channels from "./components/Channels";
import Community from "./components/Community";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <Hero />
      <HotFeed />
      <RankSection />
      <FollowUp />
      <Channels />
      <Community />
      <Testimonials />
      <Faq />
      <Footer />
    </main>
  );
}